import { config as pathConfig } from './path.config';
import { config as addressConfig } from './address.config';
import { config as productsConfig } from './products.config';
import { config as selectDateConfig } from './select-date.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as reviewConfig } from './review.config';
import { config as completePageConfig } from './complete-page.config';
import { config as modeConfig } from './mode.config';
import { PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { getAppointmentsDetails, getAnalyticsData } from './analytics.config';
import { createHeadline } from './headline.config';
import { services } from '../../services.constant';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
    extraClassName: '',
    url: 'additional-information',
  },
];

export const config = {
  ...pathConfig,
  ...addressConfig,
  ...productsConfig,
  ...selectDateConfig,
  ...aboutYouConfig,
  ...reviewConfig,
  ...completePageConfig,
  mode: modeConfig,
  serviceName: services.MEASURE.name,
  PROGRESS_BAR_ITEMS,
  getAppointmentsDetails,
  getAnalyticsData,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
  isMeasureService: true,
  isServiceWithoutShops: true,
  isServiceWithoutPartners: true,
};
